import Icon from "@chakra-ui/icon";
import React from "react";
export default function LockIcon({ ...props }) {
  return (
    <Icon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 7.33333H3.33333C2.59695 7.33333 2 7.93028 2 8.66666V13.3333C2 14.0697 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0697 14 13.3333V8.66666C14 7.93028 13.403 7.33333 12.6667 7.33333Z"
        stroke="#ACACBE"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.66666 7.33333V4.66666C4.66666 3.78261 5.01785 2.93476 5.64297 2.30964C6.26809 1.68452 7.11593 1.33333 7.99999 1.33333C8.88404 1.33333 9.73189 1.68452 10.357 2.30964C10.9821 2.93476 11.3333 3.78261 11.3333 4.66666V7.33333"
        stroke="#ACACBE"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Icon>
  );
}
